import invoiceServices from '../services/Invoice'

const getPendingInvoiceLogic = async (userToken, businessId, invoiceId, type, page, perPage, search) => {
    const dataResp = invoiceServices.getPendingInvoiceService(userToken, businessId, invoiceId, type, page, perPage, search)
    return dataResp;
}

const sentInvoiceToEmailLogic = async (userToken, businessId, invoiceId) => {
  const dataResp = invoiceServices.sentInvoiceToEmailService(userToken, businessId, invoiceId)
  return dataResp
}

const invoiceLogic = {
  getPendingInvoiceLogic,
  sentInvoiceToEmailLogic
}

export default invoiceLogic;
